<template>
    <div class="flex justify-center mt-10 align-center">
        <div class="w-full max-w-xs">
          <h1>LES CARTES INTERACTIVES DU BURUNDI </h1>
            <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
              <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                  Username
                </label>
                <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" v-model="username" type="text" placeholder="Username">
              </div>
              <div class="mb-6">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                  Password
                </label>
                <input class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="password" v-model="password" type="password" placeholder="******************">
                <p class="text-red-500 text-xs italic">{{ errorMessage}}</p>
              </div>
              <div class="flex items-center justify-between">
                <butto @click="loginTocart" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
                 Se Connecter 
                </butto>
                
              </div>
            </form>
            <p class="text-center text-gray-500 text-xs">
              &copy;2024 Acme Corp. All rights reserved. ARB 
            </p>
          </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            username : "",
            password : "",
            errorMessage : ''
        }
    },
    methods:{
        loginTocart(){
           // alert(`${this.username} ${this.password}`);
            if(this.$store.state.user.username === this.username && this.$store.state.user.password === this.password){
               
                localStorage.setItem('isLogin', true);
                this.$store.state.localLogin = true;
            }else{
              this.errorMessage = "Username ou mot de passe incorrect";
                alert("Username ou mot de passe incorrect");
            }
        }
    }, 
}
</script>

